import { Send } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { pdf } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { notify } from '../../../utils/notification';
import { useMailSend } from '../hooks/useMailSend';
import type { InvoiceManagementInvoicePdfData } from './InvoiceManagementInvoicePdfDocument';
import { InvoiceManagementInvoicePdfDocument } from './InvoiceManagementInvoicePdfDocument';

type InvoiceManagementSendEmailButtonProps = {
  data: InvoiceManagementInvoicePdfData | null;
};

export const InvoiceManagementSendEmailButton = ({ data }: InvoiceManagementSendEmailButtonProps) => {
  const { t } = useTranslation();
  const { sendMail, isLoading } = useMailSend();

  if (!data) {
    return null;
  }

  const sendEmail = async () => {
    if (isLoading) return;

    const recipientEmail = data.customer?.email;
    if (!recipientEmail) {
      notify.negative({ message: t('invoice.send.missingRecipientEmail') });
      return;
    }

    try {
      const invoiceNumber = data.number ?? '';

      const document = pdf(<InvoiceManagementInvoicePdfDocument data={data} />);
      const blob = await document.toBlob();

      const file = new File([blob], `upominej-faktura-${invoiceNumber}.pdf`, { type: 'application/pdf' });

      await sendMail({
        file,
        invoiceId: data.id,
      });

      notify.positive({ message: t('invoice.send.success') });
    } catch (error) {
      console.error(error);
      notify.negative({ message: t('invoice.send.error') });
    }
  };

  return (
    <LoadingButton variant="outlined" startIcon={<Send />} loading={isLoading} disabled={isLoading} onClick={sendEmail}>
      {t('invoice.send')}
    </LoadingButton>
  );
};
